import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { cn } from '@/lib/utils';

interface LanguageSwitcherProps {
  className?: string;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ className }) => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'zh' ? 'en' : 'zh';
    i18n.changeLanguage(newLang);
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className={cn(
        "hover:text-photo-accent border hover:border-photo-accent px-3 py-1 rounded-full text-sm transition-all duration-300",
        className
      )}
    >
      {i18n.language === 'zh' ? 'EN' : '中文'}
    </Button>
  );
};

export default LanguageSwitcher; 